/* DNA Auto — mobile behaviours (Sept 2026). Phones only; pairs with dna-mobile.css.
   1. moves each product tile's quick-add into the image tile (the round "+")
   2. keeps the bottom bar's cart badge in step with Dawn's cart icon
   3. bottom bar buttons: search (focus the pinned pill), menu (open Dawn's drawer), cart (open the drawer when there is one)
   4. product page: a sticky buy bar that appears once the real "Add to cart" has scrolled off the top, question chips under the buy buttons
   5. back arrow on sub-pages
   6. "Pick up where you left off": the last parts viewed on this phone (localStorage only), shown on the home and cart pages
   7. contact page: prefills the message from ?topic=&product=&sku= (the product-page chips) */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 749px)');
  var booted = false;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function moveQuickAdds(root) {
    $$('.card-wrapper .quick-add', root).forEach(function (q) {
      var card = q.closest('.card');
      if (!card || card.classList.contains('card--horizontal')) return;
      var inner = card.querySelector('.card__inner');
      if (inner && q.parentElement !== inner) inner.appendChild(q);
    });
  }

  function syncBadge() {
    var badge = $('.dna-mnav__badge');
    if (!badge) return;
    var bubble = $('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
    var n = 0;
    if (bubble) n = parseInt(bubble.textContent, 10) || 0;
    else if ($('#cart-icon-bubble .cart-count-bubble')) n = 99;
    badge.textContent = n ? String(n) : '';
  }

  function openMenu() {
    var summary = $('header-drawer details > summary, .header__icon--menu');
    if (summary) { summary.click(); return true; }
    return false;
  }

  function focusSearch() {
    var input = $('.dna-msearch__form input[type="search"]');
    if (!input) { window.location.href = '/search'; return; }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(function () { input.focus(); try { input.select(); } catch (e) { /* ignore */ } }, 180);
  }

  function wireNav() {
    var nav = $('.dna-mnav');
    if (!nav) return;
    var searchBtn = $('[data-dna-search]', nav);
    if (searchBtn) searchBtn.addEventListener('click', focusSearch);
    var menuBtn = $('[data-dna-menu]', nav);
    if (menuBtn) menuBtn.addEventListener('click', function () { if (!openMenu()) window.location.href = '/collections'; });
    var cartLink = $('[data-dna-cart]', nav);
    if (cartLink) cartLink.addEventListener('click', function (ev) {
      var drawer = $('cart-drawer');
      var icon = $('#cart-icon-bubble');
      if (drawer && icon && typeof drawer.open === 'function') { ev.preventDefault(); drawer.open(icon); }
    });
    $$('[data-dna-back]').forEach(function (b) {
      b.addEventListener('click', function () {
        var inSite = window.dnaInstant && window.dnaInstant.depth && window.dnaInstant.depth() > 0;   // instant navigations keep document.referrer stale
        if (window.history.length > 1 && (inSite || (document.referrer && document.referrer.indexOf(window.location.host) !== -1))) window.history.back();
        else window.location.href = '/';
      });
    });
  }

  var stickyOff = null;                                     // tear-down of the previous sticky-buy wiring (instant navigation re-runs it)
  function wireStickyBuy() {
    if (stickyOff) { stickyOff(); stickyOff = null; }
    var bar = $('.dna-satc');
    var real = $('.product__info-container .product-form__submit, .product-form__submit');
    if (!bar || !real) { document.body.classList.remove('dna-has-satc'); return; }
    document.body.classList.add('dna-has-satc');
    var btn = $('.dna-satc__btn', bar);
    var sub = $('.dna-satc__sub', bar);
    var headerH = function () { var h = document.querySelector('.section-header'); return h ? h.offsetHeight : 120; };
    var ticking = false;
    function place() {
      ticking = false;
      var r = real.getBoundingClientRect();
      bar.classList.toggle('is-on', r.bottom < headerH() + 8);
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(place); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    stickyOff = function () { window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onScroll); };
    place();
    function mirror() {
      var off = real.disabled || real.getAttribute('aria-disabled') === 'true';
      btn.disabled = off;
      var label = (real.querySelector('span:not(.sold-out-message):not(.icon-wrap)') || real).textContent.trim();
      btn.textContent = off ? (label || 'Sold out') : (label || 'Add to cart');
      if (sub) { sub.textContent = off ? 'Sold out' : 'In stock'; sub.classList.toggle('dna-satc__sub--out', off); }
      var price = $('.product__info-container .price--large .price-item--sale, .product__info-container .price--large .price-item--regular');
      var amount = $('.dna-satc__amount', bar);
      if (price && amount) amount.textContent = price.textContent.trim();
    }
    mirror();
    new MutationObserver(mirror).observe(real, { attributes: true, childList: true, subtree: true, characterData: true });
    var priceBox = $('.product__info-container .price--large');
    if (priceBox) new MutationObserver(mirror).observe(priceBox.parentElement || priceBox, { childList: true, subtree: true, characterData: true });
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      real.click();
      btn.classList.add('is-busy');
      setTimeout(function () { btn.classList.remove('is-busy'); }, 1200);
    });
  }

  // ---- recently viewed (this browser only)
  var RECENT_KEY = 'dna_recent';
  function readRecent() { try { var v = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function writeRecent(list) { try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 12))); } catch (e) { /* private mode */ } }
  function noteProductVisit() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var list = readRecent().filter(function (h) { return h !== m[1]; });
    list.unshift(m[1]);
    writeRecent(list);
  }
  function money(cents) { try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100); } catch (e) { return '$' + (cents / 100).toFixed(2); } }
  function esc(t) { return String(t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function renderRecent() {
    var boxes = $$('.dna-recent');
    if (!boxes.length) return;
    var here = (window.location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
    var handles = readRecent().filter(function (h) { return h !== here; }).slice(0, 8);
    if (!handles.length) return;
    boxes.forEach(function (box) {
      var clear = $('[data-dna-recent-clear]', box);
      if (clear) clear.addEventListener('click', function () { writeRecent([]); boxes.forEach(function (b) { b.hidden = true; }); var t = $('[data-dna-recent-tab]'); if (t) t.hidden = true; });
    });
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      var html = '';
      items.forEach(function (p) {
        if (!p) return;
        var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?.*)?$/i, '_300x$1$2') : '';
        html += '<a class="dna-recent__item" href="' + esc(p.url) + '">' +
          '<span class="dna-recent__media">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="dna-recent__price">' + money(p.price) + '</span>' +
          '<span class="dna-recent__title">' + esc(p.title) + '</span>' +
          '<span class="dna-recent__stock' + (p.available ? '' : ' is-out') + '">' + (p.available ? 'In stock' : 'Sold out') + '</span></a>';
      });
      if (!html) return;
      boxes.forEach(function (box) { var row = $('[data-dna-recent-row]', box); if (row) { row.innerHTML = html; box.hidden = false; } });
      var tab = $('[data-dna-recent-tab]');
      if (tab) tab.hidden = false;
    });
  }

  // ---- account sheet: the hosted Shopify sign-in page has no way out but the logo, so the Account button opens
  //      this white in-store sheet (✕ top-right) and only "Sign in" goes to the hosted page
  var acctOpen = false;
  function acctVehicleName() {
    try { var v = JSON.parse(localStorage.getItem('dna_vehicle') || 'null'); if (v && v.make) return [v.year, v.make, v.model, v.body, v.engine].filter(Boolean).join(' · '); } catch (e) { /* ignore */ }
    return '';
  }
  function fillAcctVehicle() {
    var card = $('[data-dna-acct-vehicle]'); if (!card) return;
    var name = acctVehicleName();
    var label = $('[data-dna-acct-vehicle-name]', card), change = $('[data-dna-acct-vehicle-change]', card), go = $('[data-dna-acct-vehicle-go]', card);
    var list = $('[data-dna-acct-garage]', card), shop = $('[data-dna-acct-vehicle-shop]', card);
    var garage = window.dnaAssistant && window.dnaAssistant.garage ? window.dnaAssistant.garage.list() : null;
    if (name) { label.textContent = name; label.classList.add('is-set'); change.hidden = false; go.textContent = 'Find parts for it'; if (shop) shop.hidden = false; }
    else { label.textContent = "Tell us your vehicle and we'll show parts that fit."; label.classList.remove('is-set'); change.hidden = true; go.textContent = 'Add my vehicle'; if (shop) shop.hidden = true; }
    if (list) {
      if (garage && garage.vehicles.length > 1) {
        list.hidden = false;
        list.innerHTML = garage.vehicles.map(function (v) {
          var k = [v.year || '', v.make || '', v.model || '', v.body || '', v.engine || ''].join('|').toLowerCase();
          return '<button type="button" class="dna-acct__chip' + (k === garage.active ? ' is-active' : '') + '" data-dna-acct-garage-select="' + k.replace(/"/g, '&quot;') + '">' + [v.year, v.make === 'Ram' && !v.model ? 'Ram' : v.make, v.model].filter(Boolean).join(' ').replace(/</g, '&lt;') + '</button>';
        }).join('');
      } else { list.hidden = true; list.innerHTML = ''; }
    }
  }
  function openAccount() {
    var sheet = $('#dna-account'); if (!sheet) return false;
    fillAcctVehicle(); renderRecent();
    sheet.hidden = false; acctOpen = true; document.body.classList.add('dna-acct-open');
    try { history.pushState({ dnaAcct: 1 }, ''); } catch (e) { /* ignore */ }
    return true;
  }
  function closeAccount(pop) {
    var sheet = $('#dna-account'); if (!sheet || !acctOpen) return;
    sheet.hidden = true; acctOpen = false; document.body.classList.remove('dna-acct-open');
    if (pop) { try { if (history.state && history.state.dnaAcct) history.back(); } catch (e) { /* ignore */ } }
  }
  function wireAccount() {
    var sheet = $('#dna-account'); if (!sheet) return;
    var link = $('.dna-mnav a[href*="/account"]');
    if (link) link.addEventListener('click', function (ev) { if (openAccount()) ev.preventDefault(); });
    $$('[data-dna-acct-close]', sheet).forEach(function (b) { b.addEventListener('click', function () { closeAccount(true); }); });
    window.addEventListener('popstate', function () { if (acctOpen) closeAccount(false); });
    var openAssist = function (opts) { closeAccount(true); setTimeout(function () { if (window.dnaAssistant) window.dnaAssistant.open(opts || {}); else window.location.href = '/?assist=1'; }, 60); };
    var go = $('[data-dna-acct-vehicle-go]', sheet);
    if (go) go.addEventListener('click', function () { openAssist(acctVehicleName() ? {} : (window.dnaAssistant && window.dnaAssistant.supported ? { listen: true } : {})); });
    var change = $('[data-dna-acct-vehicle-change]', sheet);
    if (change) change.addEventListener('click', function () { openAssist({ fresh: true }); });
    sheet.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-dna-acct-garage-select]'); if (!b) return;
      ev.preventDefault(); if (window.dnaAssistant && window.dnaAssistant.garage) { window.dnaAssistant.garage.select(b.getAttribute('data-dna-acct-garage-select')); fillAcctVehicle(); }
    });
    $$('[data-dna-assist]', sheet).forEach(function (a) { a.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); openAssist({}); }, true); });
    sheet.addEventListener('touchmove', function (ev) { if (!ev.target.closest('.dna-acct__body')) ev.preventDefault(); }, { passive: false });
  }

  // ---- product page: the question chips go under the buy buttons
  function placeProductChips() {
    var tpl = $('#dna-pchips-tpl');
    var buttons = $('.product__info-container .product-form__buttons') || $('.product__info-container .product-form');
    if (!tpl || !buttons) return;
    if ($('.dna-pchips') || $('.dna-fit')) return;                       // already placed (page restored from an instant-nav snapshot)
    var node = tpl.content.firstElementChild.cloneNode(true);
    var host = buttons.closest('product-form') || buttons;
    host.parentElement.insertBefore(node, host.nextSibling);
    var fitTpl = $('#dna-fit-tpl');
    if (fitTpl) { var fit = fitTpl.content.firstElementChild.cloneNode(true); host.parentElement.insertBefore(fit, node); }
  }

  // ---- contact page: prefill from the product-page chips
  function prefillContact() {
    var body = $('#ContactForm-body, textarea[name="contact[body]"]');
    if (!body || body.value) return;
    var q = new URLSearchParams(window.location.search);
    var product = q.get('product'), sku = q.get('sku'), topic = q.get('topic'), pre = q.get('body');
    if (pre) { body.value = pre; body.dispatchEvent(new Event('input', { bubbles: true })); return; }
    if (!product && !topic) return;
    var part = product ? product + (sku ? ' (part # ' + sku + ')' : '') : 'a part';
    var text = '';
    if (topic === 'source') text = 'Hi DNA Auto, can you find ' + (q.get('part') || 'a part') + ' for my ' + (q.get('vehicle') || 'vehicle') + '?\n\nAnything else I should mention (VIN, trim, part number): \n';
    else if (topic === 'fitment') text = 'Hi DNA Auto, does ' + part + ' fit my vehicle?\n\nYear / make / model / engine (or VIN): \n';
    else if (topic === 'bulk') text = 'Hi DNA Auto, I need more than one of ' + part + '. Quantity: \n';
    else if (topic === 'commercial') text = 'Hi DNA Auto, a question about my commercial account:\n\n';
    else text = 'Hi DNA Auto, I have a question about ' + part + ':\n\n';
    body.value = text;
    body.dispatchEvent(new Event('input', { bubbles: true }));
    setTimeout(function () { try { body.focus(); body.setSelectionRange(body.value.length, body.value.length); } catch (e) { /* ignore */ } }, 300);
  }

  // ======================================================================= commercial accounts ("pro") — every screen size
  // A customer tagged `pro` (+ `pro-tier-N`) gets: a commercial strip under the header, "Your price" on tiles and the
  // product page, bulk-price requests, the commercial dashboard on the home page (snippets/dna-pro-home.liquid), the
  // commercial checkout page, and part lookup. window.DNA_PRO comes from snippets/dna-pro-config.liquid.
  function pro() { return (window.DNA_PRO && window.DNA_PRO.customer) || null; }
  function proCfg() { return window.DNA_PRO || { proxy: false, flatShip: 0, codes: {}, tiers: {}, pages: {} }; }
  function proMoney(n) { return '$' + Number(n).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function proPriceOf(pp, tier) { if (!pp) return null; var v = pp[String(tier)]; return typeof v === 'number' ? v : null; }
  function proStrip() {
    var p = pro(); if (!p || $('.dna-pro-strip')) return;
    var host = $('.section-header') || $('#MainContent'); if (!host) return;
    var cfg = proCfg(), tier = cfg.tiers[String(p.tier)] || 'Trade';
    var el = document.createElement('div'); el.className = 'dna-pro-strip';
    el.innerHTML = '<span class="dna-pro-strip__tag">Commercial</span><span>' + esc(p.company || p.name || 'Business account') + ' · Tier ' + p.tier + ' ' + esc(tier) + '</span>' +
      (cfg.flatShip > 0 ? '<span class="dna-pro-strip__ship">Flat-rate shipping ' + proMoney(cfg.flatShip) + '</span>' : '<span class="dna-pro-strip__ship">Flat-rate shipping</span>') +
      '<a href="/">Dashboard</a><a href="' + esc(cfg.pages.garage || '/pages/shop-for-my-vehicle') + '">My vehicles</a><a href="' + esc(cfg.pages.checkout || '/pages/commercial-checkout') + '">Commercial checkout</a>';
    if (host.id === 'MainContent') host.insertBefore(el, host.firstChild); else host.parentNode.insertBefore(el, host.nextSibling);
  }
  function proCards() {
    var p = pro(); if (!p) return;
    $$('.card-wrapper[data-dna-pro]').forEach(function (card) {
      if (card.querySelector('.dna-pro-price')) return;
      var pp; try { pp = JSON.parse(card.getAttribute('data-dna-pro') || 'null'); } catch (e) { pp = null; }
      var mine = proPriceOf(pp, p.tier); if (mine == null || !pp.list || mine >= pp.list) return;
      var price = card.querySelector('.price'); if (!price) return;
      var el = document.createElement('div'); el.className = 'dna-pro-price';
      el.innerHTML = '<b>' + proMoney(mine) + '</b> <span>your price · list ' + proMoney(pp.list) + '</span>';
      price.parentNode.insertBefore(el, price.nextSibling);
    });
  }
  function proProduct() {
    var p = pro(); if (!p) return;
    var tpl = $('#dna-pro-tpl'); if (!tpl || $('.dna-pro-box')) return;
    var buttons = $('.product__info-container .product-form__buttons') || $('.product__info-container .product-form'); if (!buttons) return;
    var host = buttons.closest('product-form') || buttons;
    var node = tpl.content.firstElementChild.cloneNode(true);
    var pp; try { pp = JSON.parse(node.getAttribute('data-dna-pro') || 'null'); } catch (e) { pp = null; }
    var mine = proPriceOf(pp, p.tier), cfg = proCfg(), tier = cfg.tiers[String(p.tier)] || 'Trade';
    var line = node.querySelector('.dna-pro-box__price');
    if (line) {
      if (mine != null && pp.list && mine < pp.list) line.innerHTML = '<b>' + proMoney(mine) + '</b> <span>your Tier ' + p.tier + ' ' + esc(tier) + ' price · list ' + proMoney(pp.list) + '</span>';
      else if (pp && pp.list) line.innerHTML = '<b>' + proMoney(pp.list) + '</b> <span>list price · no tier discount on this item' + (pp.floor ? '' : '') + '</span>';
      else line.hidden = true;
    }
    var ltl = node.querySelector('.dna-pro-box__ltl'); if (ltl) ltl.hidden = !(pp && pp.ltl);
    host.parentElement.insertBefore(node, host);
    var amount = $('.dna-satc__amount'); if (amount && mine != null && pp.list && mine < pp.list) amount.textContent = proMoney(mine);
  }
  function proQuote(btn) {
    var p = pro(); if (!p) return;
    var handle = btn.getAttribute('data-handle') || location.pathname.split('/products/')[1] || '', title = btn.getAttribute('data-title') || document.title.split(' – ')[0].split(' | ')[0], sku = btn.getAttribute('data-sku') || '';
    var box = btn.closest('.dna-pro-box') || btn.parentNode, form = box.querySelector('.dna-pro-quote');
    if (form) { form.hidden = !form.hidden; return; }
    form = document.createElement('form'); form.className = 'dna-pro-quote';
    form.innerHTML = '<label>Quantity <input type="number" min="2" step="1" name="qty" required placeholder="e.g. 24"></label><label>Note <input type="text" name="note" placeholder="Timing, repeat order, target price (optional)"></label><button type="submit">Send request</button><p class="dna-pro-quote__status"></p>';
    box.appendChild(form);
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var qty = form.qty.value, note = form.note.value, st = form.querySelector('.dna-pro-quote__status');
      if (proCfg().proxy) {
        st.textContent = 'Sending…';
        fetch('/apps/pro/quote', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ handle: handle, title: title, sku: sku, qty: qty, note: note }) })
          .then(function (r) { return r.json(); }).then(function (j) { st.textContent = j.ok ? 'Request #' + j.id + ' sent — we\'ll answer with a firm price, usually within one business day. It will show on your dashboard.' : (j.error || 'Could not send.'); if (j.ok) { form.qty.disabled = form.note.disabled = true; form.querySelector('button').disabled = true; } })
          .catch(function () { st.textContent = 'Could not send — try again or use the contact page.'; });
      } else {
        var body = 'Bulk price request\nQuantity: ' + qty + '\nProduct: ' + title + '\nSKU: ' + sku + '\nHandle: ' + handle + '\nCompany: ' + (p.company || '') + '\nEmail: ' + (p.email || '') + '\nNote: ' + note + '\n';
        location.href = '/pages/contact?topic=bulk&body=' + encodeURIComponent(body);
      }
    });
    form.qty.focus();
  }
  // ---- commercial dashboard (home page)
  function proHome() {
    var p = pro(), home = $('#dna-pro-home'); if (!p || !home || home.dnaWired) return;
    home.dnaWired = true;
    var cfg = proCfg(), form = $('[data-dna-pro-lookup]', home), out = $('[data-dna-pro-results]', home), mic = $('[data-dna-pro-mic]', home);
    var portal = $('[data-dna-pro-portal]', home), pnote = $('[data-dna-pro-portal-note]', home); if (portal && !cfg.proxy) { portal.hidden = true; if (pnote) pnote.hidden = false; }
    var progress = $('[data-dna-pro-progress]', home); if (progress) progress.textContent = p.tier >= 3 ? 'Top tier' : 'Next tier from ' + (p.tier === 1 ? '$2,500' : '$10,000') + ' per quarter — ask us to review any time';
    function render(items, fallback) {
      if (!items.length) { out.innerHTML = '<p class="dna-pro__muted">Nothing matched. Try the manufacturer part number without spaces, or a keyword.</p>'; out.hidden = false; return; }
      out.innerHTML = '<table class="dna-pro__table"><tbody>' + items.map(function (it) {
        var mine = it.pro != null ? it.pro : proPriceOf(it.pp, p.tier), list = it.price != null ? it.price : (it.p != null ? it.p / 100 : null);
        var h = it.h || it.handle, t = it.t || it.title;
        return '<tr><td><a href="/products/' + esc(h) + '">' + esc(t) + '</a><div class="dna-pro__muted">' + esc(it.brand || it.v || '') + (it.sku ? ' · ' + esc(it.sku) : '') + (it.part ? ' · ' + esc(it.part) : '') + (it.ltl ? ' · LTL freight' : '') + '</div></td>' +
          '<td class="dna-pro__num">' + (mine != null && list != null && mine < list ? '<b>' + proMoney(mine) + '</b><s>' + proMoney(list) + '</s>' : (list != null ? '<b>' + proMoney(list) + '</b>' : '')) + '</td>' +
          '<td>' + (it.vid || it.in_stock !== false ? '<a class="dna-pro__mini" href="/products/' + esc(h) + '">View</a>' : '<span class="dna-pro__muted">out</span>') + '</td></tr>';
      }).join('') + '</tbody></table>' + (fallback ? '<p class="dna-pro__muted">Showing store search results; exact part-number lookup switches on with the commercial server.</p>' : '');
      out.hidden = false;
    }
    function lookup(q) {
      q = (q || '').trim(); if (q.length < 2) return;
      out.hidden = false; out.innerHTML = '<p class="dna-pro__muted">Looking up ' + esc(q) + '…</p>';
      var fb = function () {
        fetch('/search?view=dna-json&type=product&options[prefix]=last&q=' + encodeURIComponent(q), { credentials: 'same-origin' }).then(function (r) { return r.json(); })
          .then(function (j) { render((j.items || []).slice(0, 12), true); }).catch(function () { out.innerHTML = '<p class="dna-pro__muted">Lookup failed — try the search bar.</p>'; });
      };
      if (cfg.proxy) fetch('/apps/pro/lookup?q=' + encodeURIComponent(q), { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error(); return r.json(); }).then(function (j) { render(j.items || [], false); }).catch(fb);
      else fb();
    }
    if (form) form.addEventListener('submit', function (ev) { ev.preventDefault(); lookup(form.q.value); });
    if (mic) {
      var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (!SR) mic.hidden = true;
      else mic.addEventListener('click', function () {
        var rec = new SR(); rec.lang = 'en-US'; rec.interimResults = false; mic.classList.add('is-on');
        rec.onresult = function (e) { var t = (e.results[0][0].transcript || '').trim(), toks = t.split(/\s+/), shorts = toks.filter(function (x) { return /^[A-Za-z0-9-]{1,3}$/.test(x); }).length;
          form.q.value = toks.length > 1 && shorts >= toks.length * 0.6 ? toks.join('') : t; lookup(form.q.value); };
        rec.onend = function () { mic.classList.remove('is-on'); }; rec.onerror = rec.onend;
        try { rec.start(); } catch (e) { mic.classList.remove('is-on'); }
      });
    }
    if (cfg.proxy) {
      fetch('/apps/pro/me', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (me) {
        var box = $('[data-dna-pro-quotes]', home); if (!box || !me || !me.quotes) return;
        if (!me.quotes.length) return;
        box.innerHTML = '<ul class="dna-pro__qlist">' + me.quotes.map(function (q) {
          return '<li><b>' + q.qty + ' ×</b> ' + esc(q.title || q.handle || q.sku || '') + ' — ' + (q.status === 'quoted' && q.unit_price != null ? '<span class="dna-pro__quoted">' + proMoney(q.unit_price) + ' each' + (q.valid_until ? ' until ' + esc(q.valid_until) : '') + '</span>' + (q.reply ? '<div class="dna-pro__muted">' + esc(q.reply) + '</div>' : '') : '<span class="dna-pro__muted">' + esc(q.status) + '</span>') + '</li>';
        }).join('') + '</ul>';
      }).catch(function () { /* proxy off */ });
    }
  }
  // ---- cart: the way into the commercial checkout
  function proCart() {
    var p = pro(); if (!p) return;
    var cfg = proCfg(), url = cfg.pages.checkout || '/pages/commercial-checkout';
    $$('.cart__ctas, .cart-drawer__footer .cart__ctas').forEach(function (ctas) {
      if (ctas.querySelector('.dna-pro-checkout')) return;
      var a = document.createElement('a'); a.className = 'button dna-pro-checkout'; a.href = url; a.textContent = 'Commercial checkout · your prices + flat-rate shipping';
      ctas.insertBefore(a, ctas.firstChild);
    });
  }
  // ---- commercial checkout page
  var STATES = { alabama: 'AL', alaska: 'AK', arizona: 'AZ', arkansas: 'AR', california: 'CA', colorado: 'CO', connecticut: 'CT', delaware: 'DE', florida: 'FL', georgia: 'GA', hawaii: 'HI', idaho: 'ID', illinois: 'IL', indiana: 'IN', iowa: 'IA', kansas: 'KS', kentucky: 'KY', louisiana: 'LA', maine: 'ME', maryland: 'MD', massachusetts: 'MA', michigan: 'MI', minnesota: 'MN', mississippi: 'MS', missouri: 'MO', montana: 'MT', nebraska: 'NE', nevada: 'NV', 'new hampshire': 'NH', 'new jersey': 'NJ', 'new mexico': 'NM', 'new york': 'NY', 'north carolina': 'NC', 'north dakota': 'ND', ohio: 'OH', oklahoma: 'OK', oregon: 'OR', pennsylvania: 'PA', 'rhode island': 'RI', 'south carolina': 'SC', 'south dakota': 'SD', tennessee: 'TN', texas: 'TX', utah: 'UT', vermont: 'VT', virginia: 'VA', washington: 'WA', 'west virginia': 'WV', wisconsin: 'WI', wyoming: 'WY', 'district of columbia': 'DC' };
  function parseAddress(text) {
    var t = String(text || '').replace(/\s+/g, ' ').trim(), out = {};
    var zip = t.match(/\b(\d{5})(?:-\d{4})?\b(?!.*\b\d{5}\b)/); if (zip) { out.zip = zip[1]; t = t.slice(0, zip.index) + t.slice(zip.index + zip[0].length); }
    var st = t.match(/,?\s*\b([A-Za-z]{2})\b\s*,?\s*$/); var code = st && Object.values(STATES).indexOf(st[1].toUpperCase()) >= 0 ? st[1].toUpperCase() : null;
    if (!code) { var low = t.toLowerCase(); Object.keys(STATES).sort(function (a, b) { return b.length - a.length; }).some(function (n) { var i = low.lastIndexOf(n); if (i >= 0 && i > low.length - n.length - 4) { code = STATES[n]; t = t.slice(0, i) + t.slice(i + n.length); return true; } return false; }); }
    else t = t.slice(0, st.index);
    if (code) out.state = code;
    var parts = t.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    if (parts.length >= 2) { out.city = parts.pop(); var unit = parts.length > 1 ? parts.pop() : ''; out.address1 = parts.join(', '); if (/^(suite|ste|unit|apt|#|bldg|floor|fl)\b/i.test(unit)) out.address2 = unit; else if (unit) out.address1 = out.address1 + ', ' + unit; }
    else if (parts.length === 1) { var m = parts[0].match(/^(.*?\b(?:st|street|ave|avenue|rd|road|dr|drive|blvd|boulevard|ln|lane|way|ct|court|pkwy|parkway|hwy|highway|trl|trail|cir|circle|pl|place)\.?)\s+(.+)$/i); if (m) { out.address1 = m[1]; out.city = m[2]; } else out.address1 = parts[0]; }
    return out;
  }
  function proCheckout() {
    var root = $('[data-dna-pro-checkout]'); if (!root || root.dnaWired) return; root.dnaWired = true;
    var p = pro(), cfg = proCfg(), form = $('[data-dna-pro-form]', root); if (!p || !form) return;
    var fields = form.querySelectorAll('[data-dna-pro-newaddr] input[name]'), newBox = $('[data-dna-pro-newaddr]', root), status = $('[data-dna-pro-status]', root);
    function setFields(a) { fields.forEach(function (f) { if (a[f.name] != null) f.value = a[f.name]; }); }
    $$('input[name="saved"]', form).forEach(function (r) { r.addEventListener('change', function () {
      if (r.value === 'new') { newBox.hidden = false; return; }
      newBox.hidden = true; var a; try { a = JSON.parse(r.getAttribute('data-addr') || '{}'); } catch (e) { a = {}; }
      setFields({ company: a.company || '', first_name: a.first_name || '', last_name: a.last_name || '', address1: a.address1 || '', address2: a.address2 || '', city: a.city || '', state: a.province_code || '', zip: a.zip || '', phone: a.phone || '' });
    }); if (r.checked) r.dispatchEvent(new Event('change')); });
    var smart = $('[data-dna-pro-smart]', root), amic = $('[data-dna-pro-addr-mic]', root);
    function applySmart() { var a = parseAddress(smart.value); if (a.address1) setFields(a); }
    if (smart) { smart.addEventListener('change', applySmart); smart.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') { ev.preventDefault(); applySmart(); } }); }
    if (amic) {
      var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (!SR) amic.hidden = true;
      else amic.addEventListener('click', function () { var rec = new SR(); rec.lang = 'en-US'; amic.classList.add('is-on'); rec.onresult = function (e) { smart.value = e.results[0][0].transcript || ''; applySmart(); }; rec.onend = function () { amic.classList.remove('is-on'); }; rec.onerror = rec.onend; try { rec.start(); } catch (e) { amic.classList.remove('is-on'); } });
    }
    var flat = $('[data-dna-pro-flat]', root); if (flat && cfg.flatShip > 0) flat.textContent = proMoney(cfg.flatShip);
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var addr = {}; fields.forEach(function (f) { addr[f.name] = f.value.trim(); });
      var lines = []; $$('[data-dna-pro-line]', root).forEach(function (l) { lines.push({ variant_id: l.getAttribute('data-variant'), quantity: +l.getAttribute('data-qty') }); });
      if (!lines.length) { status.textContent = 'Your cart is empty.'; return; }
      if (cfg.proxy) {
        if (!addr.address1 || !addr.city || !addr.state || !addr.zip) { status.textContent = 'Please complete the ship-to address.'; return; }
        status.textContent = 'Creating your order…'; form.querySelector('[data-dna-pro-submit]').disabled = true;
        fetch('/apps/pro/checkout', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ lines: lines, address: addr, po: form.po.value, note: form.note.value }) })
          .then(function (r) { return r.json(); })
          .then(function (j) { if (j.ok && j.invoice_url) { status.textContent = 'Order ' + j.name + ' created — opening secure payment…'; location.href = j.invoice_url; } else { status.textContent = j.error || 'Could not create the order.'; form.querySelector('[data-dna-pro-submit]').disabled = false; } })
          .catch(function () { status.textContent = 'Could not reach the commercial server — try again in a minute.'; form.querySelector('[data-dna-pro-submit]').disabled = false; });
      } else {
        var code = (cfg.codes || {})[String(p.tier)];
        status.textContent = 'Taking you to checkout' + (code ? ' with your tier pricing' : '') + '…';
        location.href = code ? '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcheckout' : '/checkout';
      }
    });
  }
  // ---- business-account application: a plain Shopify contact form (arrives by e-mail) until the app proxy is on,
  // then it posts to /apps/pro/apply with the certificate file and shows the result in place
  var APPLY_KEYS = { legal_business_name: 'company', state_of_registration: 'reg_state', resale_certificate_number: 'resale_number', certificate_state: 'resale_state', address: 'address1', title: 'contact_title', monthly_volume: 'volume', how_you_sell: 'sells', brands_categories: 'brands', message: 'notes' };
  function proApply() {
    var wrap = $('[data-dna-pro-apply]'), form = wrap && wrap.querySelector('form'); if (!form || form.dnaWired) return; form.dnaWired = true;
    var status = $('[data-dna-pro-apply-status]', wrap), file = $('[data-dna-pro-file]', wrap);
    if (!proCfg().proxy) return;
    if (file) file.hidden = false;
    form.addEventListener('submit', function (ev) {
      if (form.dnaFallback) return;
      ev.preventDefault();
      if (!form.checkValidity()) { form.reportValidity(); return; }
      var fd = new FormData();
      $$('input, select, textarea', form).forEach(function (el) {
        var m = /^contact\[(.+)\]$/.exec(el.name || ''); if (!m) { if (el.type === 'file' && el.files && el.files[0]) fd.append('cert', el.files[0]); return; }
        if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
        var key = m[1].toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, ''); key = APPLY_KEYS[key] || key;
        fd.append(key, el.type === 'checkbox' ? 'yes' : el.value);
      });
      status.hidden = false; status.className = 'dna-pro-apply__status'; status.textContent = 'Sending your application…';
      var btn = form.querySelector('button[type="submit"]'); if (btn) btn.disabled = true;
      fetch('/apps/pro/apply', { method: 'POST', credentials: 'same-origin', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (j.ok) { status.className += ' is-ok'; status.textContent = 'Application #' + j.id + ' received — we review by hand and e-mail you within one business day.'; form.reset(); $$('.dna-form__grid, h3, .field, .contact__button, .dna-form__note, .dna-pro-apply__check, .dna-pro-apply__note', form).forEach(function (el) { el.hidden = true; }); status.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
          else { status.className += ' is-err'; status.textContent = (j.errors || [j.error || 'Could not send the application.']).join(' '); if (btn) btn.disabled = false; }
        })
        .catch(function () { status.className += ' is-err'; status.textContent = 'Could not reach us — the form will send by e-mail instead.'; if (btn) btn.disabled = false; form.dnaFallback = true; });
    });
  }
  function proBoot() {
    proApply();
    if (!pro()) return;
    document.body.classList.add('dna-pro');
    proStrip(); proCards(); proProduct(); proHome(); proCart(); proCheckout();
    if (!document.body.dnaProWired) {
      document.body.dnaProWired = true;
      document.addEventListener('click', function (ev) { var b = ev.target.closest('[data-dna-pro-quote]'); if (b) { ev.preventDefault(); proQuote(b); } });
      new MutationObserver(function () { proCards(); proCart(); }).observe(document.body, { childList: true, subtree: true });
    }
  }

  function boot() {
    if (booted || !mq.matches) return;
    booted = true;
    var nav = $('.dna-mnav');
    if (nav && nav.dataset.page && nav.dataset.page !== 'index') document.body.classList.add('dna-subpage');
    // the header hides on scroll-down (Dawn's sticky-header 'on-scroll-up'); mirror its state on <body> for the sticky filter bar
    var hdrSection = $('.section-header');
    if (hdrSection) {
      var mirrorHeader = function () { document.body.classList.toggle('dna-header-hidden', hdrSection.classList.contains('shopify-section-header-hidden')); };
      new MutationObserver(mirrorHeader).observe(hdrSection, { attributes: true, attributeFilter: ['class'] });
      mirrorHeader();
    }
    // while a drawer is open, finger-scrolling must move the drawer, not the page behind it (iOS ignores body overflow:hidden)
    var drawerDetails = $('header-drawer details');
    var blockPageScroll = function (ev) { if (!ev.target.closest('#menu-drawer, cart-drawer, .menu-drawer__submenu')) ev.preventDefault(); };
    var lockState = false;
    var syncLock = function () {
      var open = (drawerDetails && drawerDetails.open) || !!$('cart-drawer.active');
      if (open === lockState) return;
      lockState = open;
      if (open) document.addEventListener('touchmove', blockPageScroll, { passive: false });
      else document.removeEventListener('touchmove', blockPageScroll);
    };
    if (drawerDetails) new MutationObserver(syncLock).observe(drawerDetails, { attributes: true, attributeFilter: ['open'] });
    var facetsOpen = function () { document.body.classList.toggle('dna-facets-open', !!$('.mobile-facets__wrapper > details[open]')); };
    new MutationObserver(facetsOpen).observe(document.body, { attributes: true, attributeFilter: ['open'], subtree: true });
    facetsOpen();
    var cartDrawerEl = $('cart-drawer');
    if (cartDrawerEl) new MutationObserver(syncLock).observe(cartDrawerEl, { attributes: true, attributeFilter: ['class'] });
    // on-screen keyboard (search pill, forms): the visual viewport shrinks and a fixed bottom bar would float mid-screen
    if (window.visualViewport) {
      var vv = window.visualViewport, kbdTimer = null;
      var kbd = function () {
        clearTimeout(kbdTimer);
        kbdTimer = setTimeout(function () {
          var el = document.activeElement, typing = !!(el && /INPUT|TEXTAREA|SELECT/.test(el.tagName) && el.type !== 'checkbox' && el.type !== 'radio' && el.type !== 'submit');
          document.body.classList.toggle('dna-kbd', typing && vv.height < window.innerHeight * 0.78);
        }, 60);
      };
      vv.addEventListener('resize', kbd); document.addEventListener('focusin', kbd); document.addEventListener('focusout', kbd);
    }
    noteProductVisit();
    renderRecent();
    placeProductChips();
    prefillContact();
    moveQuickAdds(document);
    syncBadge();
    wireNav();
    wireAccount();
    wireStickyBuy();
    proBoot();
    var icon = $('#cart-icon-bubble');
    if (icon) new MutationObserver(syncBadge).observe(icon, { childList: true, subtree: true, characterData: true });
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; moveQuickAdds(document); syncBadge(); });
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('cart:refresh', syncBadge);
  }

  // instant navigation (dna-instant.js) swaps the page body in place: redo everything that depends on the page
  function onNavigate() {
    if (!booted) { boot(); proBoot(); return; }
    var nav = $('.dna-mnav');
    document.body.classList.toggle('dna-subpage', !!(nav && nav.dataset.page && nav.dataset.page !== 'index'));
    noteProductVisit();
    renderRecent();
    placeProductChips();
    prefillContact();
    moveQuickAdds(document);
    syncBadge();
    wireStickyBuy();
    proBoot();
  }
  window.dnaMobile = { onNavigate: onNavigate, closeAccount: closeAccount, pro: proBoot };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); proBoot(); }); else { boot(); proBoot(); }
  if (mq.addEventListener) mq.addEventListener('change', boot); else if (mq.addListener) mq.addListener(boot);
})();
